import React, { useEffect, useState } from 'react';
import app from '../../../../libs/apiClient';
import Modal from 'react-responsive-modal';
import { NativeDatetimePicker } from '../../Utils/renderField/renderDatePicker';
const service = app.service('api/expenseTicket');
import swal from 'sweetalert2';
import moment from 'moment';

export const RescheduleModal = ({ ticketToReschedule, handleCloseModal, rescheduleSuccessAction }) => {
   const [date, setDate] = useState('');

   useEffect(() => {
      if (ticketToReschedule && ticketToReschedule.start_datetime) {
         setDate(new Date(ticketToReschedule.start_datetime));
      } else {
         setDate('');
      }
   }, [ticketToReschedule]);

   const handleSubmit = async () => {
      try {
         const formData = {
            start_datetime: moment(date).format('YYYY-MM-DD HH:mm'),
            work_order_id: ticketToReschedule.work_order_id,
         };

         swal.fire({
            title: 'Sending Form...',
            text: 'Please wait',
            icon: 'info',
         });

         const response = await service.patch(ticketToReschedule._id, formData);
         if (response && response.error) {
            swal('Error', `Error: ${response.error || 'Unknown error'}`, 'error');
         } else {
            swal('Success', 'Ticket updated successfully.', 'success');

            rescheduleSuccessAction ? rescheduleSuccessAction() : handleCloseModal();
         }
      } catch (error) {
         swal('Error', `Something went wrong: ${error.message || 'Unknown error'}`, 'error');
         console.error('Error', error);
      }
   };

   return (
      <Modal open={!!ticketToReschedule} onClose={handleCloseModal} blockScroll={false}>
         <div className="px-2">
            <div className="text-center mt-5">
               <h3 style={{ fontSize: 25 }} className="px-4">
                  Reschedule Work order
               </h3>
            </div>
            <div className="container p-4">
               <div className="row mb-3">
                  <div className="col">
                     <strong>Start Date/Time</strong>
                     <NativeDatetimePicker
                        value={date}
                        onChange={(val) => setDate(val)}
                        dateFormat={true}
                        timeFormat={true}
                     />
                  </div>
               </div>
               <div className="text-center mt-3">
                  <button className="btn btn-primary btn-lg w-100" onClick={() => handleSubmit()}>
                     Save
                  </button>
               </div>
            </div>
         </div>
      </Modal>
   );
};
